import { useState } from "react";
import { dateWithoutHour, tomorrowWithoutHour, colorIsDark } from "../../functions";

export const WeeklyUserPlanningTimeSlot = (props) => {
    const { timeSlot, date, selected } = props;
    const hour = 100 / 24;
    const aDate1 = dateWithoutHour(date) > new Date(timeSlot.start_date) ? dateWithoutHour(date) : new Date(timeSlot.start_date);
    const aDate2 = tomorrowWithoutHour(date) < new Date(timeSlot.end_date) ? tomorrowWithoutHour(date) : new Date(timeSlot.end_date);
    const duration = (aDate2 - aDate1) / 3600000;

    const durationHours = Math.floor((aDate2 - aDate1) / 3600000);
    const durationHoursMinutes = Math.round(((aDate2 - aDate1) % 3600000) / 60000);
    const durationString = durationHours + "h" + (durationHoursMinutes > 0 ? String(durationHoursMinutes).padStart(2, "0") : "");
    const left = aDate1.getHours() + aDate1.getMinutes() / 60;

    const [isHover, setIsHover] = useState(false);

    const handleMouseEnter = () => {
        setIsHover(true);
    };
    const handleMouseLeave = () => {
        setIsHover(false);
    };

    function handleClickTimeSlots(tsId, ctrlKey) {
        props.onClickTimeSlots(tsId, ctrlKey);
    };

    const isReal = timeSlot.state === "REAL";
    const isDarkBg = colorIsDark(timeSlot.hour_type.bg_color);

    const style = {
        cursor: 'pointer',
        position: "absolute",
        backgroundColor: timeSlot.hour_type.bg_color,
        backgroundImage: isReal
            ? "repeating-linear-gradient(45deg, rgba(255,255,255,0.10) 0 1px, rgba(255,255,255,0) 1px 5px)"
            : undefined,
        color: isDarkBg ? '#d0d0d0' : '#0d0d0d',
        marginLeft: left * hour + "%",
        width: duration * hour + "%",
        border: "2px solid rgba(0, 0, 0, 0.05)",
        borderRadius: "4px",
        height: "100%",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: (selected | isHover) ? '100%' : timeSlot.state === 'REAL' ? '60%' : '75%',
        boxShadow: isHover ? '1px 2px 9px #1f7d7d' : '',
        borderColor: selected ? "#1f7d7d" : timeSlot.hour_type.bg_color,
        overflow: 'hidden',
        textOverflow: 'clip clip',
        whiteSpace: 'nowrap',
        fontStyle: isReal ? 'italic' : 'normal',
        zIndex: isHover ? '10' : '0',
    };

    const strStart = aDate1.getHours() + 'h' + (aDate1.getMinutes() > 0 ? ((aDate1.getMinutes() < 10 ? '0' : '') + aDate1.getMinutes()) : '');
    const strEnd = aDate2.getHours() + 'h' + (aDate2.getMinutes() > 0 ? ((aDate2.getMinutes() < 10 ? '0' : '') + aDate2.getMinutes()) : '');

    const title = () => {
        return timeSlot.hour_type.name + "\n" + strStart + " - " + strEnd + " (" + durationString + ")";
    }

    return (
        <div
            title={title()}
            id={timeSlot.id}
            style={style}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onClick={(e => { e.preventDefault(); handleClickTimeSlots([timeSlot.id], e.ctrlKey) })}
        >

            <span className="hidden xl:flex">
                {timeSlot.hour_type.name}<br />{strStart + " - " + strEnd + " (" + durationString + ")"}
            </span>
            <span className="flex xl:hidden">
                {timeSlot.hour_type.abbreviation}<br />{strStart}<br />{strEnd}
            </span>

        </div>
    );
};
